import { Divider, HStack, Stack, Text, VStack } from "@chakra-ui/react";
import CreativeImage from "./CreativeImage";
import CreativeTextSection from "./CreativeTextSection";
import CreativeIdentitySection from "./CreativeIdentitySection";
import {
  AdCreativeImage,
  AdCreativeVideo,
} from "common/interfaces/KYDMarketing";

interface CreativePreviewProps {
  images?: AdCreativeImage[];
  videos?: AdCreativeVideo[];
  primaryText?: string;
  headlineText?: string;
  facebookPageId?: string;
  instagramActorId?: string;
  callToAction?: string;
  eventLink?: string;
  pages: any[];
  instagramAccounts: any[];
}

const CreativeReview = ({
  images = [],
  videos = [],
  primaryText,
  headlineText,
  facebookPageId,
  callToAction,
  instagramActorId,
  eventLink,
  pages,
  instagramAccounts,
}: CreativePreviewProps) => {
  const allMedia = [
    ...images.map((img) => ({ ...img, isVideo: false })),
    ...videos.map((vid) => ({ src: vid.src, type: vid.type, isVideo: true })),
  ];

  return (
    <Stack bg="#F5F5F5" rounded="lg" p={[4, 8]} w="full" gap={8}>
      {allMedia.length > 0 && (
        <Stack w="full" gap={4} direction={["column", "row"]}>
          {allMedia
            .filter((media) => media.src)
            .map((media, index) => (
              <CreativeImage
                key={index}
                src={media.src}
                type={media.type}
                isVideo={media.isVideo}
              />
            ))}
        </Stack>
      )}

      <HStack>
        <CreativeTextSection primaryText={primaryText} />

        <HStack
          justifyContent="space-between"
          gap={4}
          flexGrow={1}
          w="full"
          alignItems="flex-start"
          fontWeight="medium"
        >
          <VStack flexGrow={1} alignItems="flex-start">
            <Text color="gray.500" fontWeight="medium">
              Call to action
            </Text>
            <Text>{callToAction}</Text>
          </VStack>
        </HStack>
      </HStack>
      <Divider w="full" borderColor="gray.300" my={2} />

      <CreativeIdentitySection
        facebookPageId={facebookPageId}
        instagramActorId={instagramActorId}
        eventLink={eventLink}
        pages={pages}
        instagramAccounts={instagramAccounts}
      />
    </Stack>
  );
};

export default CreativeReview;
